"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterComponent = void 0;
var Router_1 = require("./Router");
Object.defineProperty(exports, "RouterComponent", { enumerable: true, get: function () { return Router_1.RouterComponent; } });
